<aw-texts-table
  #textTable
  [texts]="appTextStore.texts()"
  [textType]="ETextType.App"
  [isLoading]="appTextStore.isLoading()"
  [headline]="cmsTextProvider.allTexts.appHeadline"></aw-texts-table>
